module.exports = __webpack_public_path__ + "img/s2-3.97c4769e.jpg";